var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { BOverlay, BModal, BPagination, ModalPlugin } from 'bootstrap-vue';
import axios from 'axios';
import round from 'lodash/round';
import SearchForm from './components/moulding-search-form.vue';
import MouldingCard from './components/moulding-sale-card.vue';
import MouldingPopup from './components/moulding-popup.vue';
Vue.use(ModalPlugin);
let ClearanceMoulding = class ClearanceMoulding extends Vue {
    constructor() {
        super(...arguments);
        this.mouldings = [];
        this.profiles = [];
        this.colours = [];
        this.loading = false;
        this.currentKey = null;
        this.currentMoulding = null;
        this.currentParams = null;
        this.currentPage = 1;
        this.perPage = 30;
        this.totalCount = 0;
    }
    updateMouldings(formData) {
        this.loading = true;
        axios.get('/api/clearance/mouldings', { params: Object.assign(formData || {}, { currentPage: this.currentPage }) })
            .then(result => {
            this.mouldings = result.data.mouldings;
            this.totalCount = result.data.count;
            this.perPage = result.data.perPage;
            if (this.currentKey !== null) {
                this.onCurrentKeyChange();
            }
            this.loading = false;
        });
    }
    search(params) {
        this.currentParams = params;
        if (this.currentPage != 1) {
            this.currentPage = 1;
        }
        else {
            this.updateMouldings(this.currentParams);
        }
    }
    changePage() {
        this.updateMouldings(this.currentParams);
    }
    selectMoulding(key) {
        this.currentKey = key;
    }
    get popupTitle() {
        var _a;
        if (this.currentMoulding) {
            return `${round(this.currentMoulding.num_metres, 2)}m of ${this.currentMoulding.sku.slice(3)} ${(_a = this.currentMoulding.length.colour) === null || _a === void 0 ? void 0 : _a.name} ${round(this.currentMoulding.length.width_mm, 0)}mm Wide Picture Frame Moulding`;
        }
        else {
            return '';
        }
    }
    onCurrentKeyChange() {
        if (!this.currentKey || this.currentKey == null) {
            this.currentMoulding = null;
            history.replaceState(null, '', '?');
        }
        else {
            this.currentMoulding = this.mouldings.filter(item => item.sku == this.currentKey).pop() || null;
            history.replaceState(null, '', '?ref=' + this.currentKey);
        }
    }
    mounted() {
        let params = new URLSearchParams(window.location.search);
        if (params.has('ref')) {
            // Get the moulding first 
            axios
                .get('/api/clearance/moulding', { params: { sku: params.get('ref') } })
                .then(({ data }) => this.currentMoulding = data)
                .then(() => this.$bvModal.show('moulding-popup'));
        }
        // Get the possible profiles and colours
        axios.get('/api/materials/moulding/colours')
            .then(result => this.colours = result.data);
        axios.get('/api/materials/moulding/profiles')
            .then(result => this.profiles = result.data);
        this.updateMouldings(null);
    }
};
__decorate([
    Watch('currentPage')
], ClearanceMoulding.prototype, "changePage", null);
__decorate([
    Watch('currentKey')
], ClearanceMoulding.prototype, "onCurrentKeyChange", null);
ClearanceMoulding = __decorate([
    Component({
        components: {
            SearchForm,
            MouldingCard,
            MouldingPopup,
            BOverlay,
            BModal,
            BPagination
        }
    })
], ClearanceMoulding);
export default ClearanceMoulding;
